import React, {useMemo} from 'react';
import {Typography} from '@material-ui/core';

import styles from './InfoSection.scss';
import CustomGrid from '../../controls/grid/CustomGrid';

export default function InfoSection(props) {
    const {title, text, imageName, reverse} = props;

    const image = useMemo(() => (
        <CustomGrid
            item
            md={6}
            xs={12}
            container
        >
            <CustomGrid item xs={12} className={styles.stub} />
            <CustomGrid
                item
                xs={12}
            >
                <picture className={styles.videoContent}>
                    <source type="image/webp" className={styles.picture} srcSet={`static/images/${imageName}.webp 1x,
                                                  static/images/${imageName}@2x.webp 2x,
                                                  static/images/${imageName}@3x.webp 3x`} />
                    <img className={styles.picture} srcSet="static/images/${imageName}.png 1x,
                             static/images/${imageName}@2x.png 2x,
                             static/images/${imageName}@3x.png 3x"/>
                </picture>
            </CustomGrid>
        </CustomGrid>
    ), [imageName]);

    const content = useMemo(() => (
        <CustomGrid
            container
            md={6}
            xs={12}
            item
            justify="space-between"
            spacing="xl"
        >
            <CustomGrid
                item
                xs={12}
            >
                <Typography variant="h1" color="primary">
                    {title}
                </Typography>
            </CustomGrid>
            <CustomGrid
                item
                xs={12}
                className={styles.text}
            >
                <Typography
                    variant="body1"
                    dangerouslySetInnerHTML={{__html: text}}
                />
            </CustomGrid>
        </CustomGrid>
    ), [text]);

    return (
        <CustomGrid
            container
            spacing="xl"
            alignItems="flex-start"
        >
            {reverse
                ? (
                    <React.Fragment>
                        {image}
                        {content}
                    </React.Fragment>
                )
                : (
                    <React.Fragment>
                        {content}
                        {image}
                    </React.Fragment>
                )}
        </CustomGrid>
    )
}



// WEBPACK FOOTER //
// ./src/components/Index/sections/InfoSection.jsx